import React from "react";
import { Link } from "react-router-dom";
import { BASE_URL } from "../../utils/serverContextPath";

import { useTranslation } from "react-i18next";
import { useLanguage } from "../../context/LanguageContext";
import { getLabel } from "../../utils/languageUtils";


export default function ConsultantCard({
    consultant,
    isLoggedIn,
    onConsultation
}) {

    const defaultAvatar =
        "https://cdn-icons-png.flaticon.com/512/847/847969.png";

    const imageUrl = consultant.photoUrl
        ? `${BASE_URL}userapp/downloadprofile/${consultant.id}`
        : defaultAvatar;

    const stars = consultant.note || 0;

    const { t } = useTranslation();
    const { language } = useLanguage();

    return (
        <div className="consultant-card card shadow border-0">
            <div className="card-body">
                <div className="row align-items-center">
                    {/* ================= PHOTO ================= */}
                    <div className="col-xl-2 col-lg-3 col-md-4 text-center">
                        <img
                            src={imageUrl}
                            alt={consultant.fullName}
                            className="consultant-photo"
                            onError={(e) => {
                                e.target.src = defaultAvatar;
                            }}
                        />
                        <div className="mt-3">
                            <span className="badge bg-success">
                                {
                                    consultant.natureActivityType === "C"
                                        ? t("consultant.card.agriculturalConsultant")
                                        : t("consultant.card.livestockAdvisor")
                                }

                            </span>
                        </div>
                        {
                            consultant.enabled &&
                            <div className="mt-2">
                                <span className="badge bg-primary">
                                    <i className="bi bi-patch-check-fill me-1"></i>
                                    {t("consultant.card.verified")}
                                </span>

                            </div>

                        }

                    </div>

                    {/* ================= INFOS ================= */}
                    <div className="col-xl-7 col-lg-6 col-md-8">
                        <h3 className="consultant-name">
                            {consultant.fullName}
                        </h3>
                        <div className="text-muted mb-2">
                            <i className="bi bi-briefcase-fill me-2"></i>
                            {t(
                                "consultant.card.yearsExperience",
                                {
                                    count: consultant.nbAnneesExperience
                                }
                            )}
                        </div>
                        <div className="consultant-location">
                            <i className="bi bi-geo-alt-fill me-2 text-success"></i>
                            {getLabel(
                                consultant.commune,
                                "commune",
                                language
                            )}

                            {" - "}
                            {getLabel( consultant.wilaya, "wilaya", language )}
                        </div>
                        <div className="consultant-phone">
                            <i className="bi bi-telephone-fill me-2 text-success"></i>
                            {consultant.phoneNumber}
                        </div>
                        <div className="consultant-phone">
                            <i className="bi bi-envelope-fill me-2 text-success"></i>
                            {consultant.email}
                        </div>
                        {
                            consultant.webSide &&
                            <div className="consultant-web">
                                <i className="bi bi-globe2 me-2 text-success"></i>
                                <a
                                    href={consultant.webSide}
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    {consultant.webSide}
                                </a>
                            </div>
                        }
                        {/* ================= SPECIALITES ================= */}
                        <div className="mt-3">
                            {
                                consultant.specialites?.map((s) => (
                                    <span
                                        key={s.id}
                                        className="badge bg-success me-2 mb-2"
                                    >
                                        {getLabel(s, "specialite", language)}

                                    </span>
                                ))
                            }
                        </div>
                        {/* ================= ACTIVITES ================= */}
                        <div className="mt-2">
                            {
                                consultant.activityProfs?.map((a) => (
                                    <span
                                        key={a.id}
                                        className="badge bg-secondary me-2 mb-2"
                                    >

                                        {getLabel(a, "activityProf", language)}
                                    </span>
                                ))
                            }
                        </div>
                    </div>
                    {/* ================= ACTIONS ================= */}
                    <div className="col-xl-3 col-lg-3 mt-lg-0 mt-4 text-center">
                        <div className="consultant-rating mb-3">
                            {
                                [...Array(5)].map((_, i) => (
                                    <i
                                        key={i}
                                        className={`bi ${i < stars
                                                ? "bi-star-fill"
                                                : "bi-star"
                                            }`}
                                    />

                                ))

                            }

                        </div>

                        {

                            consultant.available &&

                            <div className="mb-3">
                                <span className="badge bg-success">
                                    {t("consultant.card.available")}
                                </span>

                            </div>

                        }

                        <div className="d-grid gap-2">

                            <Link
                                to={`/consultant/${consultant.id}`}
                                className="btn btn-outline-success"
                            >
                                <i className="bi bi-person-vcard me-2"></i>
                                {t("consultant.card.profile")}

                            </Link>

                            {
                                isLoggedIn &&

                                <button
                                    className="btn btn-success"
                                    onClick={() => onConsultation(consultant)}
                                >
                                    <i className="bi bi-chat-dots-fill me-2"></i>
                                    {t("consultant.card.consultation")}

                                </button>
                            }

                        </div>

                    </div>

                </div>

            </div>

        </div>

    );

}